export type DocumentType = 'receipt' | 'purchase-order' | 'delivery-note' | 'packing-list' | 'invoice' | 'other';

export interface Document {
  id: string;
  name: string;
  type: DocumentType;
  otherType?: string;
  url: string;
  size: number;
  mimeType: string;
  uploadDate: string;
  uploadedBy: string;
  metadata?: {
    [key: string]: string;
  };
}

export const DOCUMENT_TYPES: { value: DocumentType; label: string }[] = [
  { value: 'receipt', label: 'Receipt' },
  { value: 'purchase-order', label: 'Purchase Order' },
  { value: 'delivery-note', label: 'Receiver/Delivery Note' },
  { value: 'packing-list', label: 'Packing List' },
  { value: 'invoice', label: 'Invoice' },
  { value: 'other', label: 'Other' },
];